document.addEventListener("DOMContentLoaded", function(){

const buttons = document.querySelectorAll(".type-toggle");

buttons.forEach(btn => {

btn.addEventListener("click", function(){

const content = btn.nextElementSibling;

btn.classList.toggle("active");

if(content.style.maxHeight){

content.style.maxHeight = null;
content.classList.remove("open");

}else{

content.style.maxHeight = content.scrollHeight + "px";
content.classList.add("open");

}

});

});

});
